import { render, staticRenderFns } from "./OrgCreate.vue?vue&type=template&id=2437d2f9&scoped=true"
import script from "./OrgCreate.vue?vue&type=script&lang=js"
export * from "./OrgCreate.vue?vue&type=script&lang=js"
import style0 from "./OrgCreate.vue?vue&type=style&index=0&id=2437d2f9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437d2f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2437d2f9')) {
      api.createRecord('2437d2f9', component.options)
    } else {
      api.reload('2437d2f9', component.options)
    }
    module.hot.accept("./OrgCreate.vue?vue&type=template&id=2437d2f9&scoped=true", function () {
      api.rerender('2437d2f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reserve/OrgCreate.vue"
export default component.exports